import Vue from 'vue'
import Router from 'vue-router'
const m_login = r => require.ensure([], () => r(require('../indentify/login')), 'm_login')
const m_indentify = r => require.ensure([], () => r(require('../indentify/home')), 'm_indentify')
const ccic_bj = r => require.ensure([], () => r(require('../indentify/ccic_bj')), 'ccic_bj')
const ccic_gd = r => require.ensure([], () => r(require('../indentify/ccic_gd')), 'ccic_gd')
const sys_maintenance_gd = r => require.ensure([], () => r(require('../indentify/sys_maintenance_gd')), 'sys_maintenance_gd')
const management = r => require.ensure([], () => r(require('../indentify/management')), 'm_indentify')
const search = r => require.ensure([], () => r(require('../indentify/goodsSearch')), 'm_indentify')

const goodsDetail = r => require.ensure([], () => r(require('../indentify/goodsDetail')), 'm_indentify')
const sortManagement = r => require.ensure([], () => r(require('../indentify/sortPage')), 'm_indentify')

const appraiser = r => require.ensure([], () => r(require('../indentify/appraiser')), 'm_appraiser')
const all_subject_student = r => require.ensure([], () => r(require('../indentify/all_subject_student')), 'all_subject_student')


Vue.use(Router)


export default [
    
    {
      path: '/m/login',
      name: 'm_login',
      component: m_login,
      meta: ''
    },
    {
      path: '/m/identify/all_subject_student',
      name: 'all_subject_student',
      component: all_subject_student,
      // meta: {
      //   title:'identifyManagement',
      // }
    },
    {
      path: '/ccic',
      name: 'appraiser',
      component: appraiser,
    },
    {
      path: '/ccic-gd',
      name: 'ccic_gd',
      component: sys_maintenance_gd,
    },    
    {
      path: '/m/identify/sort',
      name: 'sortManagement',
      component: sortManagement,
    },

    {
      path: '/m/identify/management',
      name: 'm_indentify',
      component: m_indentify,
    },
    {
      path: '/ccic-bj',
      name: 'ccic_bj',
      component: ccic_bj,
    },

    
    {
      path: '/m/identify/innerManagement',
      name: 'management',
      component: management,
      meta: {
        title:'identifyManagement',
        keepAlive: true,
        savedPosition:true,
      }
      
    },
    {
      path: '/m/identify/search',
      name: 'search',
      component: search,
      meta: ''
    },

    {
      path: '/m/identify/detail',
      name: 'goodsDetail',
      component: goodsDetail,
      meta: ''
    },
    {
      path: '/',
      name: 'm_login',
      component: m_login
    },


  ]





// WEBPACK FOOTER //
// ./src/router/routes.js